import { Injectable } from "@angular/core";
import { SessionService } from "../../session.service";

export interface CustomerFieldMeta {
  id: string;
  name: string;
  type: string;
  group?: 'standard' | 'device' | 'custom' | string;
}

@Injectable({ providedIn: 'root' })
export class CustomerFieldsService {
  constructor(private session: SessionService) {}

  getStandardFields(): CustomerFieldMeta[] {
    // Core standard roster fields
    return [
      { id: 'appUser.created_at', name: 'Created At', type: 'Date', group: 'standard' },
      { id: 'appUser.updated_at', name: 'Updated At', type: 'Date', group: 'standard' },
      { id: 'appUser.last_name', name: 'Last Name', type: 'String', group: 'standard' },
      { id: 'appUser.first_name', name: 'First Name', type: 'String', group: 'standard' },
      { id: 'appUser.email', name: 'Email', type: 'String', group: 'standard' },
      { id: 'appUser.gender', name: 'Gender', type: 'String', group: 'standard' },
      { id: 'appUser.date_of_birth', name: 'Date of Birth', type: 'Date', group: 'standard' },
      { id: 'appUser.company', name: 'Company', type: 'String', group: 'standard' },
      { id: 'appUser.job_title', name: 'Job Title', type: 'String', group: 'standard' },
      { id: 'last_seen_at', name: 'Last Seen', type: 'Date', group: 'standard' },
      { id: 'first_seen_at', name: 'First Seen', type: 'Date', group: 'standard' },
      { id: 'allows_push', name: 'Allows Push', type: 'Boolean', group: 'device' },
      { id: 'location_permission', name: 'Location Permission', type: 'Integer', group: 'device' },
      { id: 'app_version', name: 'App Version', type: 'String', group: 'device' },
    ];
  }

  getBehavioralTraits(): CustomerFieldMeta[] {
    const catalog = this.session.currentAccountValue?.catalog?.app_users?.profile || [];
    const traits: CustomerFieldMeta[] = [];
    if (Array.isArray(catalog)) {
      for (const trait of catalog) {
        const t = trait.type;
        if (t === 'Object' || t === 'Object[]') { continue; }
        traits.push({ id: trait.id, name: trait.name, type: t, group: 'custom' });
      }
    }
    return traits;
  }

  getAllFields(): CustomerFieldMeta[] {
    const base = this.getStandardFields();
    const traits = this.getBehavioralTraits();
    // De-duplicate by id (prefer base definitions for common fields)
    const seen = new Set<string>();
    const out: CustomerFieldMeta[] = [];
    for (const f of base) {
      if (!seen.has(f.id)) { seen.add(f.id); out.push(f); }
    }
    for (const f of traits) {
      if (!seen.has(f.id)) { seen.add(f.id); out.push(f); }
    }
    return out;
  }
}


